export default {"src":"/_next/static/media/beta-mobile-default.3f1903da.svg","height":100,"width":174,"blurWidth":0,"blurHeight":0};